import React, { useState, useEffect } from 'react';
import { host_url } from '../../App';
import { ESSENSREIHENFOLGE } from './essensreihenfolgeDaten';
import './Speiseplan.css';

const WOCHENTAGE = ['Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag'];

const MAHLZEITEN_META = {
  Fruehstueck:  { label: 'Frühstück',    icon: 'bakery_dining' },
  Mittagessen:  { label: 'Mittagessen',   icon: 'lunch_dining' },
  Abendessen:   { label: 'Abendessen',    icon: 'dinner_dining' },
};

const MAHLZEITEN_REIHENFOLGE = ['Fruehstueck', 'Mittagessen', 'Abendessen'];

function getHeutigerWochentag() {
  const jsTag = new Date().getDay(); // 0 = Sonntag
  return WOCHENTAGE[jsTag === 0 ? 6 : jsTag - 1];
}

function Speiseplan() {
  const [ausgewaehlterTag, setAusgewaehlterTag] = useState(getHeutigerWochentag());
  const [ansicht, setAnsicht] = useState('essen'); // 'essen' | 'reihenfolge'
  const [daten, setDaten] = useState([]);
  // Fallback auf die hartkodierten Aushang-Daten, bis das Backend antwortet
  const [reihenfolge, setReihenfolge] = useState(ESSENSREIHENFOLGE);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${host_url}/speiseplan`)
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then((data) => {
        setDaten(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch((err) => {
        console.error('Fehler beim Laden des Speiseplans:', err);
        setDaten([]);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    fetch(`${host_url}/essensreihenfolge`)
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then((data) => {
        if (!Array.isArray(data) || data.length === 0) return;
        const map = {};
        data.forEach((e) => {
          if (!map[e.Wochentag]) map[e.Wochentag] = {};
          if (!map[e.Wochentag][e.Mahlzeit]) map[e.Wochentag][e.Mahlzeit] = [];
          map[e.Wochentag][e.Mahlzeit].push(e.Zelt);
        });
        setReihenfolge(map);
      })
      .catch((err) => {
        console.error('Fehler beim Laden der Essensreihenfolge:', err);
      });
  }, []);

  // Einträge für den gewählten Tag gruppiert nach Mahlzeit
  const tagesEintraege = daten.filter((e) => e.Wochentag === ausgewaehlterTag);

  const mahlzeitenMap = {};
  tagesEintraege.forEach((e) => {
    mahlzeitenMap[e.Mahlzeit] = e;
  });

  const tagesReihenfolge = reihenfolge[ausgewaehlterTag];

  return (
    <div className="speiseplan-container">
      <h1>Speiseplan</h1>

      {/* Umschalter Essen / Reihenfolge */}
      <div className="speiseplan-switch">
        <button
          className={`speiseplan-switch-option ${ansicht === 'essen' ? 'active' : ''}`}
          onClick={() => setAnsicht('essen')}
        >
          <span className="material-symbols-outlined">restaurant</span>
          Essen
        </button>
        <button
          className={`speiseplan-switch-option ${ansicht === 'reihenfolge' ? 'active' : ''}`}
          onClick={() => setAnsicht('reihenfolge')}
        >
          <span className="material-symbols-outlined">format_list_numbered</span>
          Reihenfolge
        </button>
      </div>

      {/* Wochentag-Tabs */}
      <div className="speiseplan-tabs">
        {WOCHENTAGE.map((tag) => (
          <button
            key={tag}
            className={`speiseplan-tab ${ausgewaehlterTag === tag ? 'active' : ''}`}
            onClick={() => setAusgewaehlterTag(tag)}
          >
            {tag.substring(0, 2)}
          </button>
        ))}
      </div>

      {/* Reihenfolge-Ansicht */}
      {ansicht === 'reihenfolge' ? (
        <>
          <p className="reihenfolge-hinweis">
            Reihenfolge, in der die Zelte zum Essen gerufen werden – gilt nur für
            Frühstück und Abendessen.
          </p>
          {tagesReihenfolge ? (
            <div className="speiseplan-meals" key={`reihenfolge-${ausgewaehlterTag}`}>
              {['Fruehstueck', 'Abendessen'].map((key) => {
                const zelte = tagesReihenfolge[key];
                if (!zelte) return null;
                const meta = MAHLZEITEN_META[key];
                return (
                  <div className="meal-card" key={key}>
                    <div className="meal-card-header">
                      <span className="material-symbols-outlined meal-card-icon">{meta.icon}</span>
                      <h2 className="meal-card-title">{meta.label}</h2>
                    </div>
                    <ol className="reihenfolge-liste">
                      {zelte.map((zelt, index) => (
                        <li key={`${zelt}-${index}`}>{zelt}</li>
                      ))}
                    </ol>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="speiseplan-empty">
              <span className="material-symbols-outlined">format_list_numbered</span>
              <p>Für {ausgewaehlterTag} ist keine Reihenfolge hinterlegt.</p>
            </div>
          )}
        </>
      ) : /* Mahlzeit-Karten */
      loading ? (
        <div className="speiseplan-empty">
          <p>Laden…</p>
        </div>
      ) : tagesEintraege.length > 0 ? (
        <div className="speiseplan-meals" key={ausgewaehlterTag}>
          {MAHLZEITEN_REIHENFOLGE.map((key) => {
            const mahlzeit = mahlzeitenMap[key];
            if (!mahlzeit) return null;
            const meta = MAHLZEITEN_META[key] || { label: key, icon: 'restaurant' };
            return (
              <div className="meal-card" key={key}>
                <div className="meal-card-header">
                  <span className="material-symbols-outlined meal-card-icon">{meta.icon}</span>
                  <h2 className="meal-card-title">{meta.label}</h2>
                </div>
                <div className="meal-card-time">
                  <span className="material-symbols-outlined">schedule</span>
                  {mahlzeit.Uhrzeit}
                </div>
                <p className="meal-card-description">{mahlzeit.Gericht}</p>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="speiseplan-empty">
          <span className="material-symbols-outlined">no_meals</span>
          <p>Für {ausgewaehlterTag} ist noch kein Speiseplan hinterlegt.</p>
        </div>
      )}
    </div>
  );
}

export default Speiseplan;
